import { css } from '@/styled-system/css';

// HotPads overrides colors.Tabs.default.bg.tab.* in the theme, but
// Constellation Tabs 10.18 still paints default tab fills and edge fades
// with bg.action.neutral.*. Bridge scoped tab instances back to the themed tokens
// (theme/component/tabs.ts: default/active -> bg.invisible, hover/pressed -> bg.softest).
export const constellationTabBackgroundOverride = css.raw({
  '& [data-c11n-component="Tabs.Tab"]': {
    backgroundColor: 'bg.invisible',
  },
  '& [data-c11n-component="Tabs.Tab"]::after': {
    background: 'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.bg.invisible} 75%, {colors.bg.invisible})',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:hover, [data-hover])': {
    backgroundColor: 'bg.softest',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:hover, [data-hover])::after': {
    background: 'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.bg.softest} 75%, {colors.bg.softest})',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:active, [data-active])': {
    backgroundColor: 'bg.softest',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:active, [data-active])::after': {
    background: 'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.bg.softest} 75%, {colors.bg.softest})',
  },
  '& [data-c11n-component="Tabs.Tab"][aria-selected="true"]': {
    backgroundColor: 'bg.invisible',
  },
  '& [data-c11n-component="Tabs.Tab"][aria-selected="true"]::after': {
    background: 'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.bg.invisible} 75%, {colors.bg.invisible})',
  },
});
